import type { Directive } from 'vue'
import { useUserStore } from '../stores/user'

type BindingVal = string | string[]

function normalize(val: BindingVal): string[] {
  return Array.isArray(val) ? val : [val]
}

export const vCan: Directive<HTMLElement, BindingVal> = {
  mounted(el, binding) {
    const store = useUserStore()
    const originalDisplay = (el as any).__vcan_display || getComputedStyle(el).display || ''

    const apply = () => {
      const needed = normalize(binding.value)
      const ok = needed.some((p) => store.permissions.includes(p as any))
      el.style.display = ok ? originalDisplay : 'none'
    }

    apply()

    const unsub = store.$subscribe(() => apply(), { detached: true })

    ;(el as any).__vcan_unsub = unsub
    ;(el as any).__vcan_display = originalDisplay
  },

  updated(el, binding) {
    const store = useUserStore()
    const needed = normalize(binding.value)
    const ok = needed.some((p) => store.permissions.includes(p as any))
    el.style.display = ok ? (el as any).__vcan_display || '' : 'none'
  },

  unmounted(el) {
    ;(el as any).__vcan_unsub?.()
  },
}
